import { AudioStreamPlayer } from 'components/AudioController/AudioStreamPlayer';
import DefaultModal from '../../../../components/Modal/DefaultModal';
import ReactButton from '../../../../components/Buttons/ReactButton';
import { Col, Form, Input, Label, Row } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import FlexSelect from 'components/Inputs/FlexSelect';
import AssessmentService from '../service';
import React, { useMemo } from 'react';
import { toast } from 'react-toastify';

export default function MonitoringForm({
  isModalOpen,
  onModalToggle,
  onSubmitForm,
  isViewMode = false,
  cdrReport,
  cdrUniqueId,
  dataReport,
  ReportService,
  paper
}) {
  const filterListCall = dataReport?.listCallInAnalyticalDTO?.filter(function (
    value
  ) {
    return value.uniqueid == cdrUniqueId;
  })[0];

  const { control, handleSubmit, watch, setValue } = useForm();

  const questionGroups = useMemo(() => {
    if (!paper?.questionGroups || !paper?.questions) {
      return [];
    }
    const enabledGroups = paper.questionGroups
      .filter((g) => g.enabled)
      .sort((a, b) => a.id - b.id);

    return enabledGroups
      .map((group) => {
        const questionGroups = paper.questions.filter(
          (q) => q.enabled && q.group_id === group.id
        );

        return {
          id: group.id,
          name: group.name,
          questions: questionGroups
        };
      })
      .filter((group) => group.questions.length > 0);
  }, [paper]);

  async function onSubmit(data) {
    let description = data.description;
    let category = data.category ?? undefined;
    delete data.description;
    delete data.category;

    const scores = Object.keys(data).map((key) => {
      return {
        question: Number(key),
        total: Number(data[key])
      };
    });

    try {
      await AssessmentService.create({
        cdrReport,
        paper: paper.id,
        description,
        category,
        scores: scores.filter(
          (score) => (score.total != undefined) != null && score.total != -1
        )
      });

      toast.success('Monitoria cadastrada com sucesso!');
      onModalToggle(false);
      onSubmitForm();
    } catch (err) {
      toast.error('Ocorreu um erro ao cadastrar monitoria.', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  }

  function onError(errors) {
    toast.error('Todas as perguntas devem ter uma pontuação preenchida');
  }

  function onCancel() {
    onModalToggle(false);
  }

  function getAverage() {
    if (!paper) return (0).toFixed(2);
    let sumOfScores = 0;
    let sumOfWeightages = 0;

    const checkedCriticalQuestions = paper.questions.filter(
      (q) => q.enabled && q.type == 'CRITICAL' && watch(`${q.id}`) != 0
    );

    if (checkedCriticalQuestions.length != 0) return (0).toFixed(2);

    paper.questions
      .filter((q) => q.enabled && q.type == 'WEIGHTAGE')
      .forEach((question) => {
        const score = watch(`${question.id}`);
        if (score && score != -1) {
          sumOfScores += score * question.weightage;
          sumOfWeightages += question.weightage;
        }
        return question;
      });

    if (sumOfScores != 0) {
      return (sumOfScores / sumOfWeightages).toFixed(2);
    }
    return sumOfScores.toFixed(2);
  }

  const renderQuestionInputs = (question) => {
    if (question.type === 'CRITICAL') {
      return (
        <Controller
          render={(props) => (
            <>
              <div className="d-flex flex-column align-items-center">
                <input
                  {...props}
                  id={`${question.id}_0`}
                  type="radio"
                  value={1}
                />
                <Label htmlFor={`${question.id}_0`}>Não</Label>
              </div>
              <div className="d-flex flex-column align-items-center">
                <input
                  {...props}
                  id={`${question.id}_1`}
                  type="radio"
                  value={0}
                />
                <Label htmlFor={`${question.id}_1`}>Sim</Label>
              </div>
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{
            required: true
          }}
        />
      );
    }

    if (paper?.type === 'basic' && question.type === 'WEIGHTAGE') {
      return (
        <Controller
          render={(props) => (
            <>
              {[1, 2, 3, 4, 5].map((value) => (
                <div
                  key={value}
                  className="d-flex flex-column align-items-center"
                >
                  <input
                    {...props}
                    id={`${question.id}_${value}`}
                    type="radio"
                    value={value}
                  />
                  <Label htmlFor={`${question.id}_${value}`}>{value}</Label>
                </div>
              ))}
              {!question.required && (
                <div className="d-flex flex-column align-items-center">
                  <input
                    {...props}
                    id={`${question.id}_exclude`}
                    type="radio"
                    value={-1}
                  />
                  <Label htmlFor={`${question.id}_exclude`}>
                    Não se aplica
                  </Label>
                </div>
              )}
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{
            required: true
          }}
        />
      );
    }

    if (paper?.type === 'advanced' && question.type === 'WEIGHTAGE') {
      return (
        <Controller
          render={(props) => (
            <>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                <div
                  key={value}
                  className="d-flex flex-column align-items-center"
                >
                  <input
                    {...props}
                    id={`${question.id}_${value}`}
                    type="radio"
                    value={value}
                  />
                  <Label htmlFor={`${question.id}_${value}`}>{value}</Label>
                </div>
              ))}
              {!question.required && (
                <div className="d-flex flex-column align-items-center">
                  <input
                    {...props}
                    id={`${question.id}_exclude`}
                    type="radio"
                    value={-1}
                  />
                  <Label htmlFor={`${question.id}_exclude`}>
                    Não se aplica
                  </Label>
                </div>
              )}
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{
            required: true
          }}
        />
      );
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Monitoria de qualidade"
      modalContainerClasses="modal-lg"
      showCloseButton={isViewMode}
    >
      <div>
        <AudioStreamPlayer
          uniqueid={cdrUniqueId}
          nameAgent={filterListCall?.nameAgent || ''}
          calldateStart={filterListCall?.callDateStartFormated || ''}
          ReportService={ReportService}
          Origem={filterListCall?.clidNum || ''}
          Queue={filterListCall?.queue || ''}
          MonitoringForm={true}
        />

        <Form
          className="needs-validation"
          onSubmit={handleSubmit(onSubmit, onError)}
        >
          {questionGroups.length > 0
            ? questionGroups.map((group) => (
                <div
                  key={group.id}
                  className="mb-4 p-3"
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px'
                  }}
                >
                  <Row className="mb-3">
                    <Col md="12">
                      <h4
                        className="mb-0 text-primary font-weight-bold"
                        style={{ fontSize: '1.2rem' }}
                      >
                        {group.name}
                      </h4>
                    </Col>
                  </Row>

                  <h6
                    className="text-muted mb-3"
                    style={{ fontSize: '0.7rem' }}
                  >
                    Perguntas da categoria:
                  </h6>

                  {group.questions.map((question, questionIndex) => (
                    <div key={question.id}>
                      <Row className="mb-3 ml-3">
                        <Col md="12" className="mb-3 text-center">
                          <span
                            className="mr-2 font-weight-bold text-primary"
                            style={{ fontSize: '0.95rem' }}
                          >
                            Pergunta {questionIndex + 1}:
                          </span>
                          <span
                            className="font-weight-400"
                            style={{ fontSize: '0.9rem' }}
                          >
                            {question.description}{' '}
                            {question.required ? '*' : ''}
                          </span>
                        </Col>
                        <Col
                          md="3"
                          className="d-flex justify-content-center mt-2"
                        >
                          <strong
                            className="text-uppercase font-weight-600"
                            style={{ fontSize: '0.85rem' }}
                          >
                            Não Conforme
                          </strong>
                        </Col>
                        <Col md="6" className="mt-2">
                          <div className="d-flex justify-content-around">
                            {renderQuestionInputs(question)}
                          </div>
                        </Col>
                        <Col
                          md="3"
                          className="d-flex justify-content-center mt-2"
                        >
                          <strong
                            className="text-uppercase font-weight-600"
                            style={{ fontSize: '0.85rem' }}
                          >
                            Conforme
                          </strong>
                        </Col>
                      </Row>
                      {questionIndex < group.questions.length - 1 && (
                        <hr
                          className="my-2 mx-3"
                          style={{ borderColor: '#dee2e6', opacity: 0.5 }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))
            : paper?.questions
                ?.filter((q) => q.enabled)
                .map((q) => (
                  <Row className="mb-5" key={q.id}>
                    <Col
                      md="12"
                      className="d-flex justify-content-center text-center"
                    >
                      <p className="font-weight-400">{`${q.description} ${
                        q.required ? '*' : ''
                      }`}</p>
                    </Col>
                    <Col md="3" className="d-flex justify-content-center">
                      <strong className="text-uppercase font-weight-600">
                        Não Conforme
                      </strong>
                    </Col>
                    <Col md="6">
                      <div className="d-flex justify-content-around">
                        {renderQuestionInputs(q)}
                      </div>
                    </Col>
                    <Col md="3" className="d-flex justify-content-center">
                      <strong className="text-uppercase font-weight-600">
                        Conforme
                      </strong>
                    </Col>
                  </Row>
                ))}

          {paper?.categories?.filter((category) => category.enabled)?.length !=
          0 ? (
            <div className="mb-2">
              <h4>{`Categoria:`}</h4>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={[
                      {
                        label: 'Selecione uma categoria',
                        value: null
                      },
                      ...paper.categories
                        .filter((category) => category.enabled)
                        .map((category) => {
                          return {
                            label: category.name,
                            value: category.id
                          };
                        })
                    ]}
                    closeMenuOnSelect={true}
                    value={props.value}
                    valueController={setValue}
                    fieldName={props.name}
                    placeholder="Selecione uma categoria"
                    labelName="label"
                    valueName="value"
                  />
                )}
                control={control}
                name={`category`}
                rules={{
                  required: false
                }}
                defaultValue={null}
              />
            </div>
          ) : null}

          <h4>{`Descrição:`}</h4>
          <Controller
            as={<Input type="textarea" rows={6} />}
            control={control}
            name={`description`}
            defaultValue={''}
            placeholder=""
          />

          {!isViewMode ? (
            <>
              <hr />
              <h4>{`Nota final: ${getAverage()}`}</h4>
              <hr />
              <ReactButton btnColor="confirmation" type="submit">
                Salvar
              </ReactButton>

              <ReactButton btnColor="cancelation" onClick={onCancel}>
                Cancelar
              </ReactButton>
            </>
          ) : null}
        </Form>
      </div>
    </DefaultModal>
  );
}
